export const getContextualTargetStyles = () => ({
  root: {
    marginTop: 20,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    maxWidth: '1100px',
  },
  targetsContainer: {
    flex: '45%',
    border: '1px solid gray',
    paddingLeft: 12,
    minWidth: '550px',
  },
  treeViewContainer: {
    '& .checkbox-inline.disabled': {
      paddingLeft: 0,
      '& input': {
        display: 'none',
      },
      '& span': {
        color: 'black',
        fontWeight: 'bold',
      },
    },
  },
  selectionContainer: {
    flex: '45%',
    border: '1px solid gray',
    padding: '5px 10px',
    marginLeft: 12,
    '& .selectedTargetsLabel': {
      fontSize: '16px',
      fontWeight: 'bold',
      margin: '10px 0px',
    },
    '& .selectedTargetButton.btn-default': {
      padding: '2px 10px',
      paddingRight: '3px',
      height: 'unset',
      '& .iconba.iconba-Cancel': {
        top: 0,
        fontWeight: 'bold',
      },
      marginLeft: '5px',
      marginBottom: '5px',
    },
    '& .categoryName': {
      fontSize: '14px',
      fontWeight: '700',
      marginTop: '10px',
      marginBottom: '2px',
    },
    '& .selectedNodesContainer': {
      paddingTop: '5px',
    },
  },
  contextualTargetTitle: {
    flex: '100%',
  },
});
